interface OrganizationBubbleProps {
    organizationName: string | null;
    isDefault: boolean;
}

/**
 * Oval bubble component for displaying organization names
 * Blue for default organization, gray for others
 */
export function OrganizationBubble({
    organizationName,
    isDefault,
}: OrganizationBubbleProps) {
    if (!organizationName) {
        return <span className="text-xs text-muted-foreground">Global</span>;
    }

    const bubbleClasses = isDefault
        ? 'bg-blue-100 text-blue-700 border-blue-300'
        : 'bg-gray-100 text-gray-700 border-gray-300';

    return (
        <span
            className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${bubbleClasses}`}
            title={
                isDefault
                    ? 'Default organization: the active organization when the user first logs in'
                    : undefined
            }
        >
            {organizationName}
        </span>
    );
}
